var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNeedsSavedSearchX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 33,
    viewBox: "0 -20 50 78"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 2491",
    d: "M10.489 16.712l3.62-3.039 3.034 3.618 7.237-6.073 3.037 3.618-10.856 9.116-6.072-7.242z",
    fill: "#ff6c00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 2492",
    d: "M29.622 5.083a17.353 17.353 0 011.436 22.918c.035.027.065.059.1.091l9.207 9.2a2.17 2.17 0 11-3.068 3.068l-9.208-9.2q-.047-.048-.091-.1a17.357 17.357 0 111.623-25.977zm-3.068 21.475a13.017 13.017 0 10-18.411 0 13.011 13.011 0 0018.411 0z",
    fill: "#ff6c00",
    fillRule: "evenodd"
  })));
}

export default SvgIconNeedsSavedSearchX;